export default __webpack_public_path__ + "static/media/villa_maria.20d391f0.jpg";